import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	title: {
		id: 'spa-apps-sidebar-next-gen.menu.reports.title',
		defaultMessage: 'Reports',
		description: 'Navigation section title.',
	},
	itemOverview: {
		id: 'spa-apps-sidebar-next-gen.menu.reports.item-overview',
		defaultMessage: 'Overview',
		description: 'Reports overview link item.',
	},
	itemBurnup: {
		id: 'spa-apps-sidebar-next-gen.menu.reports.item-burnup',
		defaultMessage: 'Burnup report',
		description: 'Burnup Report link item.',
	},
	itemBurndown: {
		id: 'spa-apps-sidebar-next-gen.menu.reports.item-burndown',
		defaultMessage: 'Sprint burndown chart',
		description: 'Burndown report link item.',
	},
	itemVelocity: {
		id: 'spa-apps-sidebar-next-gen.menu.reports.item-velocity',
		defaultMessage: 'Velocity report',
		description: 'Velocity Report link item.',
	},
	itemCumulative: {
		id: 'spa-apps-sidebar-next-gen.menu.reports.item-cumulative',
		defaultMessage: 'Cumulative flow diagram',
		description: 'Cumulative Flow Diagram link item.',
	},
	itemControl: {
		id: 'spa-apps-sidebar-next-gen.menu.reports.item-control',
		defaultMessage: 'Control chart',
		description: 'Control Chart link item.',
	},
});
